import { AxiosResponse } from "axios";
import {
  GetNotificationCampaignByIdApiResponse,
  GetNotificationCampaignRunsApiResponse,
  GetNotificationCampaignsApiResponse,
  PostNotificationCampaignApiResponse,
  PutNotificationCampaignApiResponse,
  TestNotificationCampaignApiResponse,
  TestNotificationCampaignPayload,
  UpsertNotificationCampaignPayload,
} from "app/types/notification-campaigns";
import axios from "./config";

export const getNotificationCampaignsApi = (
  storeId: number,
  query = "",
): Promise<AxiosResponse<GetNotificationCampaignsApiResponse>> =>
  axios.get<GetNotificationCampaignsApiResponse>(
    `/stores/${storeId}/notification-campaigns${query}`,
  );

export const getNotificationCampaignByIdApi = (
  storeId: number,
  campaignId: number,
): Promise<AxiosResponse<GetNotificationCampaignByIdApiResponse>> =>
  axios.get<GetNotificationCampaignByIdApiResponse>(
    `/stores/${storeId}/notification-campaigns/${campaignId}`,
  );

export const postNotificationCampaignApi = ({
  storeId,
  payload,
}: {
  storeId: number;
  payload: UpsertNotificationCampaignPayload;
}): Promise<AxiosResponse<PostNotificationCampaignApiResponse>> =>
  axios.post<PostNotificationCampaignApiResponse>(
    `/stores/${storeId}/notification-campaigns`,
    payload,
  );

export const putNotificationCampaignApi = ({
  storeId,
  campaignId,
  payload,
}: {
  storeId: number;
  campaignId: number;
  payload: UpsertNotificationCampaignPayload;
}): Promise<AxiosResponse<PutNotificationCampaignApiResponse>> =>
  axios.put<PutNotificationCampaignApiResponse>(
    `/stores/${storeId}/notification-campaigns/${campaignId}`,
    payload,
  );

export const getNotificationCampaignRunsApi = (
  storeId: number,
  campaignId: number,
): Promise<AxiosResponse<GetNotificationCampaignRunsApiResponse>> =>
  axios.get<GetNotificationCampaignRunsApiResponse>(
    `/stores/${storeId}/notification-campaigns/${campaignId}/runs`,
  );

export const postNotificationCampaignTestApi = ({
  storeId,
  payload,
}: {
  storeId: number;
  payload: TestNotificationCampaignPayload;
}): Promise<AxiosResponse<TestNotificationCampaignApiResponse>> =>
  axios.post<TestNotificationCampaignApiResponse>(
    `/stores/${storeId}/notification-campaigns/test`,
    payload,
  );
